import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ASSETS_BASE_URL = 'https://dyararts.com/pdf/';

function Amplify3DownloadPage() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Check if user has access (came from form submission)
    const hasAccess = sessionStorage.getItem('amplify3-access');
    const email = sessionStorage.getItem('amplify3-email');

    // Dev mode: Skip protection on localhost for easier development
    const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

    if (!hasAccess && !isDev) {
      // Redirect back to form if no access (production only)
      navigate('/amplify3');
      return;
    }

    setUserEmail(email || 'dev@localhost.test');
  }, [navigate]);

  const trackDownload = async (downloadType) => {
    // Track the download in database
    try {
      await fetch('/amplify3-handler.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'track_download',
          email: userEmail,
          download_type: downloadType
        })
      });
    } catch (err) {
      // Silent fail - don't block download if tracking fails
      console.error('Download tracking failed:', err);
    }
  };

  const handleDownload = (filename, downloadType) => {
    // Track the download
    trackDownload(downloadType);

    // Trigger download
    const link = document.createElement('a');
    link.href = ASSETS_BASE_URL + filename;
    link.download = filename;
    link.click();
  };

  const downloads = [
    {
      filename: 'amplify3_framework_letter.pdf',
      type: 'pdf-letter',
      format: 'American Letter',
      size: '8.5" × 11" (1.3 MB)',
      previewImage: 'https://dyararts.com/images/amplify3_us_letter.png',
      flagIcon: 'https://dyararts.com/images/flag_usa_circle.png',
      sizeClass: 'letter'
    },
    {
      filename: 'amplify3_framework_a4.pdf',
      type: 'pdf-a4',
      format: 'European A4',
      size: '210mm × 297mm (1.3 MB)',
      previewImage: 'https://dyararts.com/images/amplify3_eu_a4.png',
      flagIcon: 'https://dyararts.com/images/flag_eu_circle.png',
      sizeClass: 'a4'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-section-wrapper">
          <div className="page-section-header">
            <a href="/" className="btn-home">←</a>
            <h1>Amplify 3<span className="trademark">™</span></h1>
          </div>

          <p>PDFs are ready for download - choose your size.</p>

        <div className="a3-download-grid">
          {downloads.map((download) => (
            <div
              key={download.type}
              className="a3-download-card"
              onClick={() => handleDownload(download.filename, download.type)}
            >
              <div className="a3-card-header">
                <h2 className="a3-format-label">{download.format}</h2>
                <p className="a3-size-label">{download.size}</p>
              </div>

              <div className={`a3-preview-container ${download.sizeClass}`}>
                <img
                  src={download.previewImage}
                  alt={download.format}
                  className="a3-preview-image"
                />
                <img
                  src={download.flagIcon}
                  alt=""
                  className="a3-flag-icon"
                />
              </div>
            </div>
          ))}
        </div>

        <p>
          Want to see the framework in action? Check out my{' '}
          <a href="https://youtube.com/@dyararts" target="_blank" rel="noopener noreferrer">
            YouTube channel
          </a>{' '}
          where I break down every step of my process.
        </p>

        <div className="a3-personal-message">
          <p>
            <strong>I hate spam</strong> as much as you do, probably more. I've spent decades in tech and I know exactly how this game is played. So it goes without saying that I'll never sell or share your info. When I do reach out, it'll be because it actually matters.
          </p>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Amplify3DownloadPage;
